// extracted by mini-css-extract-plugin
export var active = "_bl-7";
export var container = "_bl-0";
export var evenWidth = "_bl-4";
export var large = "_bl-5";
export var outlet = "_bl-8";
export var slide = "_bl-2";
export var small = "_bl-6";
export var tab = "_bl-3";
export var tabs = "_bl-1";